import { Job } from '../../jobs-module/models/job.model';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContentService } from '../../lib/services/contentService';
import { Unit } from '../../settings-module/models/unit';
import { TranslateService } from '@ngx-translate/core';
import { DatePipeProxy } from '../../shared-module/pipes/datePipe';

@Component({
  selector: 'mj-about-job-info',
  templateUrl: './about-job-info.component.html',
  styleUrls: ['./about-job-info.component.scss'],
})
export class AboutJobInfoComponent implements OnChanges {
  @Input() fontColor = '#000000';
  @Input() job: Job;
  @Input() unit: Unit;

  formattedSalary;
  formattedDate;

  constructor(public cs: ContentService, private translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job && this.job) {
      this.getHumanReadableSalary();
      this.getShortDate();
    }
  }

  getHumanReadableSalary() {
    const salaryType = this.job.salary_type;
    const salaryAmount = this.job.salary_amount;
    const salaryLevel = this.job.salary;

    if (salaryType === 0 && salaryAmount != null) {
      this.formattedSalary = salaryAmount + ' kr/mnd';
    } else if (
      (salaryType === 0 && salaryAmount == null) ||
      salaryType === 2 ||
      salaryType === 3 ||
      salaryType === 4
    ) {
      this.formattedSalary = this.cs.getSalaryType(salaryType)['name'];
    } else if (salaryType === 1 && salaryLevel) {
      this.formattedSalary = this.cs.getSalary(salaryLevel)['name'];
    } else {
      this.formattedSalary = 'Etter avtale';
    }
  }

  getShortDate() {
    if (this.job.due_date) {
      this.formattedDate = new DatePipeProxy(this.translate).transform(
        new Date(this.job.due_date)
      );
    } else {
      this.formattedDate = this.translate.instant(
        'notification_footer_open_application'
      );
    }
  }
}
